<script setup lang="ts">
    import { defineAsyncComponent } from 'vue';
    import TopBannerLeft from '../components/oferta/TopBannerLeft.vue' 
    import FormarBloque from '../components/oferta/FormarBloqueNeo.vue'; 
    const MtrPlanEstudios = defineAsyncComponent(() => import('../components/oferta/MtrPlanEstudios.vue')) ; 
    const VerModelo = defineAsyncComponent(() => import('../components/oferta/VerModelo.vue'));
const PoliticaIA = defineAsyncComponent(() => import('../components/oferta/PoliticaIA.vue'))
    const CalendarioOferta = defineAsyncComponent(() => import('../components/oferta/CalendarioOferta.vue'))
    // const DescargaFolleto = defineAsyncComponent(() => import('../components/oferta/DescargaFolleto.vue')) ; 
    // const MtrModEjec = defineAsyncComponent(() => import('../components/oferta/MtrModEjec.vue')) ; 
    // const EgresadosHuma = defineAsyncComponent(() => import('../components/oferta/EgresadosHuma.vue')) ;
</script>

<template>
    <TopBannerLeft
        :img="'background-image: url(../../pagesImages/banner-merca1.jpg);'"
        :nivel="'Maestr&iacute;a en'"
        :carrera="'Mercadotecnia'"
        :frase="'Los beneficios llegan de la productividad, eficiencia, austeridad y la forma de gestionar un negocio'"
        :autor="'Carlos Slim'"
    />

    <FormarBloque
        :img="'../../pagesImages/student7.jpg'"
        :link="'/requisitos-maestria'"
        alt="Alumna de Maestría en Mercadotecnia"
        :frase="'Líderes capaces de transformar oportunidades de mercado en resultados éticos y rentables'"
        :testo1="'La Maestría en Mercadotecnia cuenta con un programa académico, que integra sólidos fundamentos teóricos y metodológicos bajo un enfoque ético, profesional y socialmente responsable, respondiendo así a las necesidades actuales de las organizaciones y empresas.'"
        :testo3="'Profesionales afines a Mercadotecnia, con conocimientos teóricos y habilidades prácticas que buscan el desarrollo de competencias holísticas, que abarca conocimientos teóricos, habilidades prácticas y actitudes profesionales.'"
    />

    <div class="flex items-center justify-center my-10">
    </div>

    <MtrPlanEstudios
        :ejecutivo="true"
    />


    <VerModelo
    ejec="/pagesImages/Programas/Maestria/Plan_De_Estudios_Mercadotecnia_Web.webp,/pagesImages/Programas/Maestria/Plan_De_Estudios_Mercadotecnia_Cel.webp"
    :escoT="false"
    :ejecT="true"
    :virtT="false" />

    <CalendarioOferta nombre="Maestría en Mercadotecnia" 
  :inicios="[true, true, false, true, false, true, false, true]"></CalendarioOferta>
    <!-- <VerModelo
    ejec="/pagesImages/Programas/Maestria-ant/maestria-mercadotecnia-ejecutivo.webp"
    :escoT="false"
    :ejecT="true"
    :virtT="false" /> -->

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-4 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block font-serif text-[42px] text-hgold text-left" style="">Estructura académica</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-xl text-left mb-3">(Bloques trimestrales):</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li><b>Contexto Mercadológico Global:</b> Fundamentos para la toma de decisiones estratégicas, contexto económico global, modelos de Mercadotecnia y ética para la práctica mercadológica.</li>
                            <li><b>Bases estratégicas de la Mercadotecnia:</b> Herramientas clave para el análisis y desarrollo de mercados, investigación de mercados, diseño de productos y servicios y estadística aplicada a los negocios.</li>
                            <li><b>Desarrollo de proyectos de Mercadotecnia:</b> De la teoría a la acción: estrategias competitivas, estrategia de negocios, planeación estratégica de mercados y proyectos en Mercadotecnia digital.</li>
                            <li><b>Posicionamiento Digital:</b> Dominio de herramientas para la era digital, herramientas web para el posicionamiento, publicidad en medios digitales y tendencias en Mercadotecnia digital.</li>
                            <li><b>Seminario de titulación:</b> Desarrollo de un proyecto aplicado para la obtención del grado.</li>
                            <!-- <li><b>Seminario de Inteligencia Artificial.</b> Conocimiento, comprensión y aplicación de las herramientas de Inteligencia Artificial en entornos académicos, profesionales y laborales, fortaleciendo las habilidades y capacidades.</li> -->
                        </ul>
                        <!-- <p>
                            Este programa está diseñado para formar especialistas en contabilidad con una visión estratégica, capaces de responder a los desafíos del entorno fiscal, financiero y corporativo con un enfoque integral y actualizado.
                        </p> -->
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/estructura-academica-educacion.webp" alt="Alt pendiente" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>

    <!-- <MtrModEjec class="mb-16" />

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Metodología</span>
                        </h2>
                        <p class="mb-4">
                            El modelo ejecutivo se desarrolla bajo la siguiente estructura:
                        </p>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Consta de 6 bloques trimestrales.</li>
                            <li>Cada bloque equivale a tres materias fusionadas, impartidas por un especialista en la materia.</li>
                            <li>Se imparten clases un día a la semana, tres horas de clases presenciales.</li>
                            <li>El modelo educativo tiene una duración de diez semanas de clases, y una semana adicional culminando con una evaluación final.</li>
                            <li>La evaluación se compone de participación en clase, foros, trabajos y examen final, integrando así un proceso de aprendizaje integral.</li>
                        </ul>
                        <p>
                            Este modelo permite a los estudiantes desarrollar habilidades especializadas con un enfoque práctico y estratégico, alineado con las exigencias del mundo profesional actual.
                        </p>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/universidad-fisica-virtual.webp" alt="Estudiantes de maestría en alta dirección corporativa universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section> -->
    
    <section class="lg:flex items-center justify-center bg-cover bg-[center] bg-no-repeat mb-16" style="background-image: url(/pagesImages/madin3.jpg); position: relative; background-attachment: fixed; background-position: left; background-repeat: no-repeat; background-size: cover; overflow: hidden; transition: transform 0.3s ease;">
        <div class="lg:flex items-center justify-center w-full h-full my-16">
            <div class="lg:flex items-center justify-between w-full max-w-[1200px]">
                <img src="/pagesImages/perfil-egresado-maestrias.webp" alt="Egresados de maestría de Mercadotecnia." class="lg:p-0 w-full lg:max-w-[520px] md:px-16 px-6 pt-6"/>
                <div class="flex flex-col lg:justify-start justify-center items-center lg:items-start lg:w-[50%] w-full lg:my-24 py-12 text-justify lg:px-0  px-8">
                    <h2>
                        <span class="block text-[28px] text-hwine leading-none text-center md:text-left">Perfil del egresado de la maestría en</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block text-hwine text-[42px] mb-4 leading-tight text-center md:text-left font-serif ">Mercadotecnia</span>
                    </h2>
                    <p class="text-justify text-gray-800 lg:hyphens-manual hyphens-auto">Líderes estratégicos capaces de identificar y aprovechar oportunidades de mercado mediante el diseño e implementación de campañas publicitarias en ambientes tradicionales y virtuales de manera efectiva. <br>Dominarán tanto la teoría como la práctica del marketing moderno, preparados para tomar decisiones estratégicas en empresas transnacionales.</p>
                    <br>
                    <router-link to="/contacto">
                        <div class="flex items-center justify-center w-[140px] h-[35px] hover:bg-hwine bg-hgold text-white  text-lg transition duration-300 ease-in-out">
                            <span>Inscr&iacute;bete</span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-4 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Cinco razones para elegir</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Universidad Humanitas:</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Modelo educativo especializado.</li>
                            <li>Excelencia académica.</li>
                            <li>Instalaciones de primer nivel.</li>
                            <li>Costos accesibles.</li>
                            <li>Acreditaciones reconocidas (SEP, ESR y GPTW).</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/beneficios-estudiar-universidad-humanitas.webp" alt="Beneficios de estudiar en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>
    <PoliticaIA />
</template>

<style scoped>
</style>